import './ReferenceButton.css';
import React from "react";
import { useNavigate } from "react-router-dom";

export default function ReferenceButton({ children, to, onClick, style, className }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    }
  };

  return (
    <button
      className={`buttonLink${className ? ` ${className}` : ''}`}
      onClick={handleClick}
      style={style}
    >
      {children}
    </button>
  );
}